import { categoryResource, CategoryResource } from '@witkac/kartamiejska-resources';
import { Category } from '@witkac/kartamiejska-shared';

import { EntityModule } from './entity.module';

/**
 * Moduł kategorii
 *
 * @export
 * @class CategoryModule
 * @extends {EntityModule<Category, CategoryResource>}
 */
export class CategoryModule extends EntityModule<Category, CategoryResource> {
  constructor() {
    super(categoryResource);
  }
}

export default new CategoryModule();
